import { ContactModalVisible } from './reducers/contactus';
export function actionGen<P>(type: ReduxActionType) {
  return (payload?: P) => {
    return {
      type,
      payload,
    } as ReduxAction<P>;
  };
}

export const setUser = actionGen<Partial<UserResp>>('SET_USER');
export const setTeamProducts =
  actionGen<TeamProductResp[]>('SET_TEAM_PRODUCTS');
export const setTeams = actionGen<TeamResp[]>('SET_TEAMS');
export const logout = actionGen<undefined>('LOGOUT');
export const switchTeam = actionGen<string>('SWITCH_TEAM');
export const updateTeam = actionGen<{
  uid: string;
  name: string;
  // desc: string;
}>('UPDATE_TEAM');
export const addTeam = actionGen<TeamResp>('ADD_TEAM');
export const setProjects = actionGen<ProjectResp[]>('SET_PROJECTS');
export const setCurrentProject = actionGen<string>('SET_CURRENT_PROJECT');
export const updateProject = actionGen<ProjectResp>('UPDATE_PROJECT');
export const createProject = actionGen<ProjectResp>('CREATE_PROJECT');

export const setCurrentResourceGroup = actionGen<string>(
  'SET_CURRENT_RESOURCEGROUP'
);
export const setResourceGroups =
  actionGen<ResourceGroup[]>('SET_RESOURCEGROUPS');
export const toggleContactModal = actionGen<ContactModalVisible>(
  'SET_CONTACTUS_VISIBLE'
);
export const toggleRechargeModal = actionGen<RechargeModalVisible>(
  'SET_RECHARGE_VISIBLE'
);
